import apiVolunteers from '@/services/api/volunteers';

export default {
    namespaced: true,
    state: {
        volunteers: []
    },
    getters: {
        getVolunteers (state) {
            return state.volunteers;
        }
    },
    mutations: {
        setVolunteers (state, payload) {
            state.volunteers = payload;
        }
    },
    actions: {
        getVolunteers (context, payload) {
            return apiVolunteers.getVolunteers(payload);
        },
        assignVolunteers (context, payload) {
            return apiVolunteers.assignVolunteers(payload.id, payload.data);
        },
        rejectFamily (context, payload) {
            return apiVolunteers.rejectFamily(payload.id, payload.data);
        },
        acceptFamily (context, payload) {
            return apiVolunteers.acceptFamily(payload.id);
        }
    }
};
